/* eslint-disable no-console */
import { setState } from './storage.js'

const shouldSkipCache = (mutation) => {
  console.log(mutation)
  if (mutation.type === 'loadFromCache') {
    return true
  }
  return false
}

const plugin = (store) => {
  store.subscribe((mutation, state) => {
    if (!shouldSkipCache(mutation)) {
      console.log('store state', JSON.stringify(state))
      setState(state).catch(err => console.warn('failed to cache state', err))
    }
  })
}

export default plugin
